import { pgaComTld } from "../components/utils"

export const PTM_LEGACY_APPLICATION_PATHS = [
  "/applications/associate",
  "/applications/affiliate",
]

export const MEMBER_APPLICATIONS_URL = `https://${pgaComTld}/member/account/applications`

export const shouldSuppressPtmLegacyApplicationRoute = (
  redirectEnabled,
  path,
) => redirectEnabled && PTM_LEGACY_APPLICATION_PATHS.includes(path)

export const redirectToMemberApplications = () => {
  window.location.href = MEMBER_APPLICATIONS_URL
}
